<h1 mat-dialog-title class="title">{{ title() }}</h1>

<span class="separator"></span>

<mat-dialog-content class="content">
  @if (text()) {
    <p>{{ text() }}</p>
  }
  <ng-content />
</mat-dialog-content>

<mat-dialog-actions class="actions__container">
  @for (action of actions(); track action.name) {
    <button mat-raised-button type="button" class="actions__button" [color]="action.color" [disabled]="action.disabled" (click)="onActionClick(action)">
      {{ action.labelKey | transloco }}
    </button>
  }
</mat-dialog-actions>
